import { SxProps } from '@mui/material'

interface SwiperButtonStyles {
  swiperButtonWrapper: SxProps
  buttonWrapper: SxProps
  arrowButton: (disabled: boolean) => SxProps
  arrowIconBox: SxProps
  arrowIcon: SxProps
  shouldShowSwiperButton: SxProps
  shouldHideSwiperButton: SxProps
}

export const swiperStyles: SwiperButtonStyles = {
  swiperButtonWrapper: {
    px: 1,
    alignSelf: 'flex-end',
  },
  shouldShowSwiperButton: {
    display: 'flex',
  },
  shouldHideSwiperButton: {
    display: 'none',
  },
  buttonWrapper: {
    display: 'flex',
    gap: 1,
    justifyContent: 'flex-end',
    flex: 1,
  },
  arrowButton: (disabled: boolean) => ({
    display: 'flex',
    width: '40px',
    height: '40px',
    padding: 1.3,
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    borderRadius: 3,
    border: '1px solid',
    borderColor: 'button.borderSecondary',
    backgroundColor: 'primary.contrast',
    boxShadow: `0px 4px 6px -1px  rgba(10, 13, 18, 0.10),
                0px 2px 4px -2px  rgba(10, 13, 18, 0.06)`,
    opacity: disabled ? 0.3 : 1,
  }),
  arrowIconBox: {
    height: 20,
    width: 20,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    color: 'text.quaternary500',
  },
  arrowIcon: {
    width: 20,
  },
}
